function IsNullOrWhitespace(input) {
  return !input || input.trim().length < 1;
}

function HasSpecialCharacters(val) {
  if (val === null || val === undefined) {
    throw new Error("Input value cannot be null or undefined");
  }
  var pattern = new RegExp(/[~`!#$%\^&*+=\-\[\]\\';,/{}()|\\":<>\?]/);
  return pattern.test(val);
}

// Same as HasSpecialCharacters but permits the dash/hyphen character (-).
// Use this when validating fields like check numbers where dashes are valid
// (e.g., "12345-6", "ACH-001").
function HasSpecialCharactersExcludingDash(val) {
  if (val === null || val === undefined) {
    throw new Error("Input value cannot be null or undefined");
  }
  var pattern = new RegExp(/[~`!#$%\^&*+=\[\]\\';,/{}()|\\":<>\?]/);
  return pattern.test(val);
}

function ProperStringValue(input) {
  // If the value is null or undefined, return an empty string
  if (input === null || input === undefined) {
    return "";
  }

  // Replace underscores with spaces, convert to Proper Case, then replace spaces back with underscores
  return input
    .replace(/_/g, " ") // Replace underscores with spaces
    .replace(/\w\S*/g, function (txt) {
      return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
    })
    .replace(/ /g, "_"); // Replace spaces back with underscores
}

// Returns true when the value matches known non-check-number patterns such as
// ACH, EFT, Direct Deposit, electronic, unknown, or all-zeros (e.g. "0000").
// The check is intentionally broad (contains-match, case-insensitive) so that
// variants like "mmddyyACH" or "1234EFT" are also caught.
function IsInvalidCheckNumber(value) {
  if (value === null || value === undefined) {
    throw new Error("Input value cannot be null or undefined");
  }

  const trimmed = value.trim();
  if (trimmed.length === 0) return false;

  const invalidPatterns = /ACH|EFT|DIRECT\s*DEPOSIT|ELECTRONIC|UNKNOWN|^0+$/i;
  return invalidPatterns.test(trimmed);
}

export { IsNullOrWhitespace, HasSpecialCharacters, IsInvalidCheckNumber, HasSpecialCharactersExcludingDash };
